import { render } from "./ThirdSection.vue?vue&type=template&id=243a9dfc&scoped=true"
import script from "./ThirdSection.vue?vue&type=script&lang=ts"
export * from "./ThirdSection.vue?vue&type=script&lang=ts"

import "./ThirdSection.vue?vue&type=style&index=0&id=243a9dfc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-243a9dfc"

export default script